<template>
  <form id="frm_action" class="club-form">
  <div class="p-formgrid">
        <div class="p-card-field div-big">
          <div class="transform-upper-case">INFOMATION</div>
          <div class="p-card-field div_check div-big">
            <label class="p-col-fixed txt-right text bold">Club status</label>
            <div class="div-active">
              <div class="p-col-6 pl-0">
                <InputText disabled="disabled" v-model="active"/>
              </div>
            </div>
          </div>
          <div class="p-card-field div_check div-big">
            <label class="p-col-fixed txt-right text bold">Club name<span class="color">*</span></label>
            <div class="div-active">
              <div class="p-col-6 pl-0">
                <InputText v-model="name" id="name"/>
              </div>
            </div>
          </div>
          <div class="p-card-field div_check div-big">
            <label class="p-col-fixed txt-right text bold">Participation age from<span class="color">*</span></label>
            <div class="div-active">
              <div class="p-col-6 pl-0">
                <v-select :clearable="false" title="Participation age from" id= "id_69" :filterable="false" multiple placeholder="Select" v-model="selAges" :options="listAges" label="name" @search="fetchOptionsAges" class="p-col-width p-inputtext p-component p-filled p-1">
                    <span slot="no-options" @click="$refs.select.open = false">
                        no data
                    </span>
                </v-select>
                <input class="input_tmp_validator" id="age_id">
                <div>
                  <label v-for="(item, index) in selAges" :key="index" class="cus-tags">
                    <span class="cs-tag">
                      {{item.name}}
                    </span>
                    <i class="fas fa-times cs-icon" v-on:click="removeChip(index, selAges)"></i>
                  </label>
                </div>
              </div>
            </div>
          </div>
          
          <div class="p-card-field div_check div-big">
            <label class="p-col-fixed txt-right text bold">Gender<span class="color">*</span></label>
            <div class="div-active">
              <div class="p-col-6 pl-0">
                <Dropdown v-model="gender" :options="genderList" optionLabel="label" placeholder="Select" id=""/>
                <input class="input_tmp_validator" id="gender">
              </div>
            </div>
          </div>
          <div class="transform-upper-case">ACTIVITY INFOMATION</div>
          <div class="p-card-field div_check div-big">
            <label class="p-col-fixed txt-right text bold">Operating time<span class="color">*</span></label>
            <div class="div-active">
              <div class="p-col-6 pl-0">
                <v-select :clearable="false" title="Operating time" id= "id_69" :filterable="false" multiple placeholder="Select" v-model="selOperating" :options="listOperating" label="name" @search="fetchOptionsOperating" class="p-col-width p-inputtext p-component p-filled p-1">
                    <span slot="no-options" @click="$refs.select.open = false">
                        no data
                    </span>
                </v-select>
                <input class="input_tmp_validator" id="operating_time_id">
                <div>
                  <label v-for="(item, index) in selOperating" :key="index" class="cus-tags">
                    <span class="cs-tag">
                      {{item.name}}
                    </span>
                    <i class="fas fa-times cs-icon" v-on:click="removeChip(index, selOperating)"></i>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="p-card-field div_check div-big">
            <label class="p-col-fixed txt-right text bold">Country</label>
            <div class="div-active">
              <div class="p-col-6 pl-0">
                <v-select :clearable="false" title="Country" id= "a1" :filterable="false" placeholder="Select" v-model="selCountry" :options="listCountry" label="name" @search="fetchOptionsCountry" class="p-col-width p-inputtext p-component p-filled p-1">
                    <span slot="no-options" @click="$refs.select.open = false">
                        no data
                    </span>
                </v-select>
                <input class="input_tmp_validator" id="country_id">
              </div>
            </div>
          </div>
          <div class="p-card-field div_check div-big">
            <label class="p-col-fixed txt-right text bold">City/ Province</label>
            <div class="div-active">
              <div class="p-col-6 pl-0">
                <v-select :clearable="false" title="Province" id= "a1" :filterable="false" placeholder="Select" v-model="selProvince" :options="listProvince" label="name" @search="fetchOptionsProvince" class="p-col-width p-inputtext p-component p-filled p-1" @open="getListProvince">
                    <span slot="no-options" @click="$refs.select.open = false">
                        no data
                    </span>
                </v-select>
                <input class="input_tmp_validator" id="province_id">
              </div>
            </div>
          </div>
          <div class="p-card-field div_check div-big">
            <label class="p-col-fixed txt-right text bold">District</label>
            <div class="div-active">
              <div class="p-col-6 pl-0">
                <v-select :clearable="false" title="District" id= "a1" :filterable="false" placeholder="Select" v-model="selDistrict" :options="listDistrict" label="name" @search="fetchOptionsDistrict" class="p-col-width p-inputtext p-component p-filled p-1" @open="getListDistrict">
                    <span slot="no-options" @click="$refs.select.open = false">
                        no data
                    </span>
                </v-select>
                <input class="input_tmp_validator" id="district_id">
              </div>
            </div>
          </div>
          <div class="p-card-field div_check div-big">
            <label class="p-col-fixed txt-right text bold">Membership fee<span class="color">*</span></label>
            <div class="div-active">
              <div class="d-flex p-col-6 pl-0">
                <div class="p-col-8 px-0">
                  <InputNumber v-model="membership_fee" locale="de-DE" :min="0" :minFractionDigits="0" id="membership_fee"/>
                </div>
                <div class="p-col-4 pr-0">
                  <Dropdown v-model="currency_code" :options="CurrencyList" optionLabel="label" placeholder="Select" id=""/>
                  <input class="input_tmp_validator" id="currency_code">
                </div>
              </div>
            </div>
          </div>
          <div class="p-card-field div_check div-big">
            <label class="p-col-fixed txt-right text bold">Schedule<span class="color">*</span></label>
            <div class="div-active">
              <div class="p-col-6 pl-0">
                <Dropdown v-model="schedule" :options="schedule_arr" optionLabel="label" placeholder="Select" id=""/>
                <input class="input_tmp_validator" id="schedule">
              </div>
            </div>
          </div>
          <div class="p-card-field div_check div-big">
            <label class="p-col-fixed txt-right text bold">Club skill<span class="color">*</span></label>
            <div class="div-active">
              <div class="p-col-6 pl-0">
                <Dropdown v-model="selSkill" :options="listSkill" optionLabel="name" placeholder="Select" id=""/>
                <input class="input_tmp_validator" id="skill">
              </div>
            </div>
          </div>
          <div class="p-card-field div_check div-big">
            <label class="p-col-fixed txt-right text bold">The reason why you choose</label>
            <div class="div-active">
              <div class="p-col-6 pl-0">
                <Textarea  rows="5"  v-model="note_skill" id="note_skill"/>
              </div>
            </div>
          </div>
          <div class="p-col checkbox div-active-item one-active">
            <Checkbox  v-model="is_player_experience" :binary="true"/>
            <label class="p-col-fixed txt-right text-active">Player experience </label>
          </div>
          
          <div class="p-col-6 box-experience" v-if="is_player_experience">
            <div class="p-col-6 border">
              <div class="d-flex align-items-center" v-for="items, index in experiences" :key="index">
                <div class="p-col-7">
                  {{items.name}}
                </div>
                <div class="p-col-5 number-box">
                  <InputNumber v-model="items.number" :min="0" locale="de-DE" :minFractionDigits="0" showButtons buttonLayout="horizontal" class="txt-center border no-border" decrementButtonClass="p-button-text p-button-secondary" incrementButtonClass="p-button-text p-button-secondary" incrementButtonIcon="pi pi-plus" decrementButtonIcon="pi pi-minus"/>
                </div>
              </div>
            </div>
          </div>
          
          <div class="p-card-field div_check div-big">
            <label class="p-col-fixed txt-right text bold">Club introduction</label>
            <div class="div-active">
              <div class="p-col-6 pl-0">
                <Textarea rows="5" v-model="introduction" id="introduction"/>
              </div>
            </div>
          </div>
          <div class="transform-upper-case">IMAGES</div>
          <div class="p-field p-grid div-block">
            <label class="txt-right label-thumbnail bold">Club image <small>({{images.length}}/10)</small></label>
            <div class="p-col-6">

              <div class="p-col-width disabled width-thum">
                <label class="file-select">
                  <div class="select-button">
                    <span >Browse...</span>
                  </div>
                  <input accept="image/*" multiple name="images[]" type="file" @change="onFileSelect"/>
                </label>
              </div>
              <div class="div-label-bot">
                <input class="input_tmp_validator" id="images_va">
                <label class=" txt-right label-bot-item color-text">-Accepted: PNG, JPG, JPEG, GIF </label>
                <label class=" txt-right label-bot-item color-text">-Maximum upload file size: 500MB </label>
              </div>
              <div class="box-images p-grid"  v-if="images && images.length">
                <div class="item-img p-col-6 pl-0" v-for="(item, index) in images" :key="index" >
                  <div class="button-clear" @click="onFileClear(index)"><img :src="require('../../../assets/ic_clear.svg')"/></div>
                  <img  :src="item.objectURL"/>
                </div>
              </div>
            </div>
          </div>
          
          <div class="p-field p-grid div-block">
            <label class="txt-right label-thumbnail bold">Club logo</label>
            <div class="p-col-6">

              <div class="p-col-width disabled width-thum">
                <label class="file-select">
                  <div class="select-button">
                    <span >Browse...</span>
                  </div>
                  <input accept="image/*" name="logo" type="file" @change="onFileLogoSelect"/>
                </label>
              </div>
              <div class="div-label-bot">
                <input class="input_tmp_validator" id="images_va">
                <label class=" txt-right label-bot-item color-text">-Accepted: PNG, JPG, JPEG, GIF </label>
                <label class=" txt-right label-bot-item color-text">-Maximum upload file size: 500MB </label>
              </div>
              <div class="box-images p-grid"  v-if="logo && logo.length">
                <div class="item-img p-col-6 pl-0" v-for="(item, index) in logo" :key="index" >
                  <!-- <div class="button-clear" @click="onFileClear(index)"><img :src="require('../../../assets/ic_clear.svg')"/></div> -->
                  <img  :src="item.objectURL"/>
                </div>
              </div>
            </div>
          </div>
          <div class="transform-upper-case">OTHER INFOMATION</div>
          <div class="p-card-field">
            <label class="p-col-fixed bold">Instagram</label>
            <div class="p-col-6 pl-0">
              <InputText :autoResize="true"  rows="1" maxlength="255" v-model="instagram"  id="link" type="text"  placeholder="https://www.instagram.com/" />
            </div>
          </div>
          
          <div class="p-card-field">
            <label class="p-col-fixed bold">Stadium</label>
            <div class="p-col-6 pl-0">
              <v-select :clearable="false" title="Stadium" id= "a1" :filterable="false" placeholder="Select" v-model="selStadium" :options="listStadium" label="name" @search="fetchOptionsStadium" class="p-col-width p-inputtext p-component p-filled p-1">
                    <span slot="no-options" @click="$refs.select.open = false">
                        no data
                    </span>
                </v-select>
                <input class="input_tmp_validator" id="stadium_id">
            </div>
          </div>

          <div class="p-col checkbox div-active-item one-active">
            <Checkbox  v-model="recruit_members" :binary="true"/>
            <label class="p-col-fixed txt-right text-active">Recruit member </label>
          </div>
          
          <div class="p-col checkbox div-active-item one-active">
            <Checkbox  v-model="is_ban" :binary="true"/>
            <label class="p-col-fixed txt-right text-active">Banned </label>
          </div>
          
        </div>
    <Toolbar class="fixed-bottom-toolbar">
      <template slot="right">
        <Button
          label="Cancel"
          @click="backToList()"
          class="p-button-warning cancel"
        />
        <Button
          v-if="mode == 'edit'"
          :label="'Save'"
          @click="saveData()"
          class="p-button-success save"
        />
        <Button
          v-else
          :label="'Save'"
          @click="saveData()"
          class="p-button-success save"
        />
      </template>
    </Toolbar>
  </div>
  </form>
</template>

<script>
// import CkditorCore from '../CkditorCore';
import DataServices from '@/core/DataServices'
import moment from 'moment';
export default {
  // components: {
  //   CkditorCore
  // },
  props: {
    mode: String,
    model: Object,
    users: Array
  },
  data() {
    return {
      active: '',
      name: '',
      gender: 1,
      ages: [],
      operating_time: [],
      country: null,
      province: null,
      district: null,
      membership_fee: null,
      schedule: null,
      note_skill: null,
      is_player_experience: false,
      introduction: null,
      instagram: null,
      stadium_id: null,
      recruit_members: true,
      is_ban: false,
      skill_id: null,
      currency_code: null,
      logo: [],
      logosDeletes: [],
      listCountry: [],
      listCountryAll: [],
      selCountry: null,
      
      listOperating: [],
      listOperatingAll: [],
      selOperating: null,
      
      listAges: [],
      listAgesAll: [],
      selAges: null,
      
      experiences: [],

      listProvince: [],
      listProvinceAll: [],
      selProvince: null,
      
      listDistrict: [],
      listDistrictAll: [],
      selDistrict: null,
      
      listSkill: [],
      selSkill: null,
      
      validationErrors: {},
      formMode: this.mode,
      images: [],
      imagesDeletes: [],
      maxFileSize: 1000000, // 1MB
      maxFiles: 10,
      saving:false,
      content : '',
      content_en : '',
      imgDelete : [],
      time_zone_local : moment.tz.guess(),
      selType:{ value: 'OTHER', name: 'Khác'},
      list_rank : [],//.unshift({ value: 'OTHER', name: 'Khác'})
      genderList: [{ value: 1, label: 'Male'}, { value: 2, label: 'Female'}, { value: 3, label: 'Mix'}],
      CurrencyList: [{value: "VND", label: "VND"}, {value: "USD", label: "USD"}, {value: "KRW", label: "KRW"}],
      schedule_arr: [
        {
          value: "TIME",
          label: "Every time"
        },
        {
          value: "WEEK",
          label: "Every week"
        },
        {
          value: "MONTH",
          label: "Every month"
        },
        {
          value: "YEAR",
          label: "Every year"
        }
      ],
      
      listStadium: [],
      listStadiumAll: [],
      selStadium: null
    }
  },
  async mounted() {
    await this.getListAges();
    await this.getListOperating();
    await this.getListCountry();
    await this.getListSkill();
    await this.getListExperience();
    await this.getListStadium();
    if (this.model !== undefined && Object.keys(this.model).length > 0) {
      this.selStadium = this.model.stadium ? {id: this.model.stadium.id, name: this.model.stadium.name} : null;
      this.selDistrict = this.model.district ? {id: this.model.district.id, name: this.model.district.district_lang[0].name} : null;
      this.selCountry = this.model.country ? {id: this.model.country.id, name: this.model.country.country_lang[0].name} : null;
      this.selProvince = this.model.province ? {id: this.model.province.id, name: this.model.province.province_lang[0].name} : null;
      this.selSkill = {id : this.model.skill.id, name : this.model.skill.skill_lang[0].name};
      this.name = this.model.club_name;
      this.currency_code = this.CurrencyList.filter(f => f.value == this.model.currency_code)[0];
      this.gender = this.genderList.filter(f => f.value == this.model.gender)[0];
      this.active = this.model.status;
      this.is_ban = this.model.is_ban == 'BANNED' ? true : false;
      this.schedule = this.schedule_arr.filter(f => f.value == this.model.schedule)[0];
      if (this.model.clubs_age.length >0) {
        for(let i =0; i<this.model.clubs_age.length; i++) {
          this.ages.push({
            id: this.model.clubs_age[i].ages_id,
            name: this.model.clubs_age[i].age.age_lang[0].name
          })
        }
        this.selAges = this.ages;
      }
      if (this.model.club_operating_time.length >0) {
        this.selOperating = [];
        for(let i =0; i<this.model.club_operating_time.length; i++) {
          this.selOperating.push({
            id: this.model.club_operating_time[i].operating_time.id,
            name: this.model.club_operating_time[i].operating_time.operating_time_lang[0].name
          })
        }
      }
      if(this.model.clubs_player_experience.length > 0) {
        for(let j=0; j < this.model.clubs_player_experience.length; j++) {
          this.experiences.map(m => {
            if (m.id == this.model.clubs_player_experience[j].experience_id) {
              m.number = this.model.clubs_player_experience[j].number;
            }
          })
        }
      }
      this.membership_fee = this.model.membership_fee;
      this.note_skill = this.model.note_skill;
      this.is_player_experience = this.model.is_player_experience;
      this.introduction = this.model.introduction;
      this.instagram = this.model.instagram;
      this.recruit_members = this.model.recruit_members;
      if (!this.$commonFuction.isEmpty(this.model.images)) {
        for (let i=0; i < this.model.images.length; i++) {
          let url = this.model.images[i]
          let split = url.split('/')
          let fileName = split[split.length - 1]
          let obj = {'name': fileName, 'file': '', 'objectURL': url,type:'old_edit'}//type:'old_edit' nếu gặp type này ko update avatar
          this.images.push(obj)
        }
      }
      
      if (!this.$commonFuction.isEmpty(this.model.logo)) {
        let url = this.model.logo
        console.log("urlrrrrrr", url)
        let split = url.split('/')
        let fileName = split[split.length - 1]
        let obj = {'name': fileName, 'file': '', 'objectURL': url,type:'old_edit'}//type:'old_edit' nếu gặp type này ko update avatar
        this.logo.push(obj)
      }
    }
  },
  methods: {
    async removeChip(index, data) {
      data.splice(index, 1);
    },
    async getListAges(){

      var where_key = {
        deleted : {_eq : false},
        active : {_eq : true},
      }
      let {data} = await this.$apollo.query({
        query: DataServices.getList('age',{"fields" : `id age_lang(where: {lang: {_eq: "en"}}){name}`}),
        variables: {
          where_key: where_key,
          orderBy:[{ordinal: 'asc'}, {created_at : 'desc'}]
        },
        fetchPolicy: 'no-cache'
      })
      var list = data[Object.keys(data)];
      var list_time = [];
      // console.log("list===",list);
      for (let i = 0; i < list.length; i++) {
        const e = list[i];
        list_time.push({id : e.id, name :e.age_lang[0].name});
      }
      this.listAges = list_time;
      this.listAgesAll = list_time;
    },
    async fetchOptionsAges(search, loading){
      console.log(loading);
      console.log('search',search);
      if(search !== '' && search !== null){
        var where_key = {
          // plain_name:{_ilike: "%"+this.$commonFuction.SkipVN(search).trim()+"%"},
          deleted : {_eq : false},
          active : {_eq : true},
          age_lang: {lang: {_eq: "en"}, name:{_ilike: "%"+this.$commonFuction.SkipVN(search).trim()+"%"}},
        };
        let {data} = await this.$apollo.query({
          query: DataServices.getList('age',{"fields" : `id age_lang(where: {lang: {_eq: "en"}}){name}`}),
          variables: {
            where_key: where_key,
            orderBy:[{ordinal: 'asc'}, {created_at : 'desc'}]
          },
          fetchPolicy: 'no-cache'
        })
        var list = data[Object.keys(data)];
        var list_time = [];
        // console.log("list===",list);
        for (let i = 0; i < list.length; i++) {
          const e = list[i];
          list_time.push({id : e.id, name :e.age_lang[0].name});
        }
        this.listAges = list_time;
      }else{
        // cosnole.log("dasdasd")
        this.listAges = this.listAgesAll
      }
    },
    
    async getListOperating(){

      var where_key = {
        deleted : {_eq : false},
        active : {_eq : true},
      }
      let {data} = await this.$apollo.query({
        query: DataServices.getList('operating_time',{"fields" : `id operating_time_lang(where: {lang: {_eq: "en"}}){name}`}),
        variables: {
          where_key: where_key,
          orderBy:[{ordinal: 'asc'}, {created_at : 'desc'}]
        },
        fetchPolicy: 'no-cache'
      })
      var list = data[Object.keys(data)];
      var list_time = [];
      // console.log("list===",list);
      for (let i = 0; i < list.length; i++) {
        const e = list[i];
        list_time.push({id : e.id, name :e.operating_time_lang[0].name});
      }
      this.listOperating = list_time;
      this.listOperatingAll = list_time;
    },
    async fetchOptionsOperating(search, loading){
      console.log(loading);
      console.log('search',search);
      if(search !== '' && search !== null){
        var where_key = {
          // plain_name:{_ilike: "%"+this.$commonFuction.SkipVN(search).trim()+"%"},
          deleted : {_eq : false},
          active : {_eq : true},
          operating_time_lang: {lang: {_eq: "en"}, name:{_ilike: "%"+this.$commonFuction.SkipVN(search).trim()+"%"}},
        };
        let {data} = await this.$apollo.query({
          query: DataServices.getList('operating_time',{"fields" : `id operating_time_lang(where: {lang: {_eq: "en"}}){name}`}),
          variables: {
            where_key: where_key,
            orderBy:[{ordinal: 'asc'}, {created_at : 'desc'}]
          },
          fetchPolicy: 'no-cache'
        })
        var list = data[Object.keys(data)];
        var list_time = [];
        // console.log("list===",list);
        for (let i = 0; i < list.length; i++) {
          const e = list[i];
          list_time.push({id : e.id, name :e.operating_time_lang[0].name});
        }
        this.listOperating = list_time;
      }else{
        // cosnole.log("dasdasd")
        this.listOperating = this.listOperatingAll
      }
    },
    async getListSkill(){

      var where_key = {
        deleted : {_eq : false},
        active : {_eq : true},
      }
      let {data} = await this.$apollo.query({
        query: DataServices.getList('skill',{"fields" : `id skill_lang(where: {lang: {_eq: "en"}}){name}`}),
        variables: {
          where_key: where_key,
          orderBy:[{ordinal: 'asc'}, {created_at : 'desc'}]
        },
        fetchPolicy: 'no-cache'
      })
      var list = data[Object.keys(data)];
      var list_time = [];
      // console.log("list===",list);
      for (let i = 0; i < list.length; i++) {
        const e = list[i];
        list_time.push({id : e.id, name :e.skill_lang[0].name});
      }
      this.listSkill = list_time;
    },
    
    async getListExperience(){

      var where_key = {
        deleted : {_eq : false},
        active : {_eq : true},
      }
      let {data} = await this.$apollo.query({
        query: DataServices.getList('experience',{"fields" : `id experience_lang(where: {lang: {_eq: "en"}}){name}`}),
        variables: {
          where_key: where_key,
          orderBy:[{ordinal: 'asc'}, {created_at : 'desc'}]
        },
        fetchPolicy: 'no-cache'
      })
      var list = data[Object.keys(data)];
      var list_time = [];
      // console.log("list===",list);
      for (let i = 0; i < list.length; i++) {
        const e = list[i];
        list_time.push({id : e.id, name :e.experience_lang[0].name, number: 0});
      }
      this.experiences = list_time;
    },
    
    async getListCountry(){

      var where_key = {
        deleted : {_eq : false},
        active : {_eq : true},
      }
      let {data} = await this.$apollo.query({
        query: DataServices.getList('country',{"fields" : `id country_lang(where: {lang: {_eq: "en"}}){name}`}),
        variables: {
          where_key: where_key,
          orderBy:[{ordinal: 'asc'}, {created_at : 'desc'}]
        },
        fetchPolicy: 'no-cache'
      })
      var list = data[Object.keys(data)];
      var list_time = [];
      // console.log("list===",list);
      for (let i = 0; i < list.length; i++) {
        const e = list[i];
        list_time.push({id : e.id, name :e.country_lang[0].name});
      }
      this.listCountry = list_time;
      this.listCountryAll = list_time;
    },
    async fetchOptionsCountry(search, loading){
      console.log(loading);
      console.log('search',search);
      if(search !== '' && search !== null){
        var where_key = {
          // plain_name:{_ilike: "%"+this.$commonFuction.SkipVN(search).trim()+"%"},
          deleted : {_eq : false},
          active : {_eq : true},
          country_lang: {lang: {_eq: "en"}, name:{_ilike: "%"+this.$commonFuction.SkipVN(search).trim()+"%"}},
        };
        let {data} = await this.$apollo.query({
          query: DataServices.getList('country',{"fields" : `id country_lang(where: {lang: {_eq: "en"}}){name}`}),
          variables: {
            where_key: where_key,
            orderBy:[{ordinal: 'asc'}, {created_at : 'desc'}]
          },
          fetchPolicy: 'no-cache'
        })
        var list = data[Object.keys(data)];
        var list_time = [];
        // console.log("list===",list);
        for (let i = 0; i < list.length; i++) {
          const e = list[i];
          list_time.push({id : e.id, name :e.country_lang[0].name});
        }
        this.listCountry = list_time;
      }else{
        // cosnole.log("dasdasd")
        this.listCountry = this.listCountryAll
      }
    },
    async getListProvince(){

      var where_key = {
        deleted : {_eq : false},
        active : {_eq : true},
        country_id: {_eq: this.selCountry ? this.selCountry.id : 0}
      }
      let {data} = await this.$apollo.query({
        query: DataServices.getList('province',{"fields" : `id province_lang(where: {lang: {_eq: "en"}}){name}`}),
        variables: {
          where_key: where_key,
          orderBy:[{ordinal: 'asc'}, {created_at : 'desc'}]
        },
        fetchPolicy: 'no-cache'
      })
      var list = data[Object.keys(data)];
      var list_time = [];
      // console.log("list===",list);
      for (let i = 0; i < list.length; i++) {
        const e = list[i];
        list_time.push({id : e.id, name :e.province_lang[0].name});
      }
      this.listProvince = list_time;
      this.listProvinceAll = list_time;
    },
    async fetchOptionsProvince(search, loading){
      console.log(loading);
      console.log('search',search);
      if(search !== '' && search !== null){
        var where_key = {
          // plain_name:{_ilike: "%"+this.$commonFuction.SkipVN(search).trim()+"%"},
          deleted : {_eq : false},
          active : {_eq : true},
          province_lang: {lang: {_eq: "en"}, name:{_ilike: "%"+this.$commonFuction.SkipVN(search).trim()+"%"}},
          country_id: {_eq: this.selCountry ? this.selCountry.id : 0}
        };
        let {data} = await this.$apollo.query({
          query: DataServices.getList('province',{"fields" : `id province_lang(where: {lang: {_eq: "en"}}){name}`}),
          variables: {
            where_key: where_key,
            orderBy:[{ordinal: 'asc'}, {created_at : 'desc'}]
          },
          fetchPolicy: 'no-cache'
        })
        var list = data[Object.keys(data)];
        var list_time = [];
        // console.log("list===",list);
        for (let i = 0; i < list.length; i++) {
          const e = list[i];
          list_time.push({id : e.id, name :e.province_lang[0].name});
        }
        this.listProvince = list_time;
      }else{
        // cosnole.log("dasdasd")
        this.listProvince = this.listProvinceAll
      }
    },
    
    async getListDistrict(){

      var where_key = {
        deleted : {_eq : false},
        active : {_eq : true},
        province_id: {_eq: this.selProvince ? this.selProvince.id : 0}
      }
      let {data} = await this.$apollo.query({
        query: DataServices.getList('district',{"fields" : `id district_lang(where: {lang: {_eq: "en"}}){name}`}),
        variables: {
          where_key: where_key,
          orderBy:[{ordinal: 'asc'}, {created_at : 'desc'}]
        },
        fetchPolicy: 'no-cache'
      })
      var list = data[Object.keys(data)];
      var list_time = [];
      // console.log("list===",list);
      for (let i = 0; i < list.length; i++) {
        const e = list[i];
        list_time.push({id : e.id, name :e.district_lang[0].name});
      }
      this.listDistrict = list_time;
      this.listDistrictAll = list_time;
    },
    async fetchOptionsDistrict(search, loading){
      console.log(loading);
      console.log('search',search);
      if(search !== '' && search !== null){
        var where_key = {
          // plain_name:{_ilike: "%"+this.$commonFuction.SkipVN(search).trim()+"%"},
          deleted : {_eq : false},
          active : {_eq : true},
          province_lang: {lang: {_eq: "en"}, name:{_ilike: "%"+this.$commonFuction.SkipVN(search).trim()+"%"}},
          province_id: {_eq: this.selProvince ? this.selProvince.id : 0}
        };
        let {data} = await this.$apollo.query({
          query: DataServices.getList('district',{"fields" : `id district_lang(where: {lang: {_eq: "en"}}){name}`}),
          variables: {
            where_key: where_key,
            orderBy:[{ordinal: 'asc'}, {created_at : 'desc'}]
          },
          fetchPolicy: 'no-cache'
        })
        var list = data[Object.keys(data)];
        var list_time = [];
        // console.log("list===",list);
        for (let i = 0; i < list.length; i++) {
          const e = list[i];
          list_time.push({id : e.id, name :e.district_lang[0].name});
        }
        this.listDistrict = list_time;
      }else{
        // cosnole.log("dasdasd")
        this.listDistrict = this.listDistrictAll
      }
    },
    
    
    async getListStadium(){
      var where_key = {
        deleted : {_eq : false},
        active : {_eq : true},
      }
      let {data} = await this.$apollo.query({
        query: DataServices.getList('stadium',{"fields" : `id name`}),
        variables: {
          where_key: where_key,
          orderBy:[{created_at : 'desc'}]
        },
        fetchPolicy: 'no-cache'
      })
      var list = data[Object.keys(data)];
      var list_time = [];
      // console.log("list===",list);
      for (let i = 0; i < list.length; i++) {
        const e = list[i];
        list_time.push({id : e.id, name :e.name});
      }
      this.listStadium = list_time;
      this.listStadiumAll = list_time;
    },
    
    async fetchOptionsStadium(search, loading){
      console.log(loading);
      console.log('search',search);
      if(search !== '' && search !== null){
        var where_key = {
          // plain_name:{_ilike: "%"+this.$commonFuction.SkipVN(search).trim()+"%"},
          deleted : {_eq : false},
          active : {_eq : true},
          name:{_ilike: "%"+this.$commonFuction.SkipVN(search).trim()+"%"},
        };
        let {data} = await this.$apollo.query({
          query: DataServices.getList('stadium',{"fields" : `id name`}),
          variables: {
            where_key: where_key,
            orderBy:[{created_at : 'desc'}]
          },
          fetchPolicy: 'no-cache'
        })
        var list = data[Object.keys(data)];
        var list_time = [];
        // console.log("list===",list);
        for (let i = 0; i < list.length; i++) {
          const e = list[i];
          list_time.push({id : e.id, name :e.name});
        }
        this.listStadium = list_time;
      }else{
        // cosnole.log("dasdasd")
        this.listStadium = this.listStadiumAll
      }
    },
    
    backToList() {
      this.$emit('back');
    },
    handleDataCkditor: function(e,key) {
      var dataContent = (e.length) ? e[0]:'';
      if (key == 'content'){
        this.content = dataContent;
      }else if (key == 'content_en'){
        this.content_en = dataContent;
      }
    },
    CallPhoneSel(){
      if(this.selUser !== undefined && this.selUser !== null){
        this.phone = this.selUser.phone
      }
    },
    async validateData() {

      let name = document.getElementById("name");
      if (this.$commonFuction.isEmpty(this.name)){
        name.setCustomValidity("Club name cannot be empty!");
      } else {
        name.setCustomValidity("");
      }
      var age = document.getElementById("age_id");
      if (this.$commonFuction.isEmptyObject(this.selAges) || this.selAges.length == 0){
        age.setCustomValidity("Participation age from cannot be empty!");
      } else {
        age.setCustomValidity("");
      }
      var gender = document.getElementById("gender");
      if (this.$commonFuction.isEmptyObject(this.gender)){
        gender.setCustomValidity("Gender cannot be empty!");
      } else {
        gender.setCustomValidity("");
      }
      var operating_time_id = document.getElementById("operating_time_id");
      if (this.$commonFuction.isEmptyObject(this.selOperating) || this.selOperating == 0){
        operating_time_id.setCustomValidity("Operating time cannot be empty!");
      } else {
        operating_time_id.setCustomValidity("");
      }
      var membership_fee = document.getElementById("membership_fee");
      if (this.$commonFuction.isEmpty(this.membership_fee)){
        membership_fee.setCustomValidity("Membership fee cannot be empty!");
      } else {
        membership_fee.setCustomValidity("");
      }
      var currency_code = document.getElementById("currency_code");
      if (this.$commonFuction.isEmptyObject(this.currency_code)){
        currency_code.setCustomValidity("Currency cannot be empty!");
      } else {
        currency_code.setCustomValidity("");
      }
      var schedule = document.getElementById("schedule");
      if (this.$commonFuction.isEmptyObject(this.schedule)){
        schedule.setCustomValidity("Schedule cannot be empty!");
      } else {
        schedule.setCustomValidity("");
      }
      var skill = document.getElementById("skill");
      if (this.$commonFuction.isEmptyObject(this.selSkill)){
        skill.setCustomValidity("Club skill cannot be empty!");
      } else {
        skill.setCustomValidity("");
      }

      var note_skill = document.getElementById("note_skill");
      if (!this.$commonFuction.isEmptyObject(this.note_skill) && this.note_skill.length > 500){
        note_skill.setCustomValidity("Please enter up to 500 characters");
      } else {
        note_skill.setCustomValidity("");
      }

      var introduction = document.getElementById("introduction");
      if (!this.$commonFuction.isEmptyObject(this.introduction) && this.introduction.length > 14000){
        introduction.setCustomValidity("Please enter up to 14000 characters");
      } else {
        introduction.setCustomValidity("");
      }
      
      var inpObj = document.getElementById("frm_action");
      if (!inpObj.checkValidity()){
        console.log('test=====================');
        inpObj.reportValidity();
        return true;
      }

    },
  
    async saveData() {
      this.$commonFuction.is_loading(true);
      if (await this.validateData()) {
        this.$commonFuction.is_loading(false);
        return;
      }
      
      var params = {
        images: this.images,
        active: this.active,
        club_name: this.name,
        gender: this.gender.value,
        ages: this.selAges.map(m=> {return m.id}),
        operating_time: this.selOperating.map(m=> {return m.id}),
        country_id: this.selCountry ? this.selCountry.id : null,
        province: this.selProvince ? this.selProvince.id : null,
        district: this.selDistrict ? this.selDistrict.id : null,
        membership_fee: this.membership_fee,
        schedule: this.schedule.value,
        note_skill: this.note_skill,
        is_player_experience: this.is_player_experience,
        introduction: this.introduction,
        instagram: this.instagram,
        stadium_id: this.selStadium ? this.selStadium.id : null,
        recruit_members: this.recruit_members,
        is_ban: this.is_ban,
        skill_id: this.selSkill.id,
        currency_code: this.currency_code.value,
        logo: this.logo,
        logosDeletes: this.logoDeletes,
        imagesDeletes: this.imgDelete,
        experiences: this.experiences
      }
        console.log("params",params)
      this.$emit('save', params);
      
    },
    isImage(file) {
      return /^image\//.test(file.type);
    },
    async onFileSelect(event) {
      let files = event.target.files || event.dataTransfer.files;
      if(files.length > 0) {
        let acceptTags = ['jpeg', 'jpg', 'gif', 'png', 'JPEG', 'JPG', 'PNG', 'GIF']
        for (let i = 0; i < files.length; i++) {
          if (!acceptTags.includes(files[i].name.split('.').pop())) {
            alert("Please upload the image file in the following format: jpeg, jpg, gif, png");
            return;
          }
        }
        if (files.length + this.images.length > this.maxFiles) {
          alert("Please upload a maximum of " + this.maxFiles + " photos");
        } else {
          var arrTemp = [], arrFiles = [];
          for (let file of files) {
            if (this.isImage(file) && file.size <= this.maxFileSize) {
              file.source = file;
              file.objectURL = window.URL.createObjectURL(file);
              arrTemp.push(file);
            }
            if (file.size > this.maxFileSize) arrFiles.push(file);
          }
          
          if (arrFiles.length > 0) {
            alert("Your image is over 500MB");
          } else {
            if (this.images.length > 0 && this.images[0].file === '') {
              this.imagesDeletes.push(this.images[0])
            }
            // this.images = [];
            this.images = this.images.concat.apply(this.images, arrTemp);
            // console.log(this.images)
            // await this.validateData()
          }
        }
      }
    },
    
    async onFileLogoSelect(event) {
      let files = event.target.files || event.dataTransfer.files;
      if(files.length > 0) {
        let acceptTags = ['jpeg', 'jpg', 'gif', 'png', 'JPEG', 'JPG', 'PNG', 'GIF']
        for (let i = 0; i < files.length; i++) {
          if (!acceptTags.includes(files[i].name.split('.').pop())) {
            alert("Please upload a maximum of " + this.maxFiles + " photos");
            return;
          }
        }
        if (files.length + this.logo.length > this.maxFiles) {
          alert("The maximum number of images is " + this.maxFiles + " images");
        } else {
          var arrTemp = [], arrFiles = [];
          for (let file of files) {
            if (this.isImage(file) && file.size <= this.maxFileSize) {
              file.source = file;
              file.objectURL = window.URL.createObjectURL(file);
              arrTemp.push(file);
            }
            if (file.size > this.maxFileSize) arrFiles.push(file);
          }
          
          if (arrFiles.length > 0) {
            alert("Your image is over 500MB");
          } else {
            if (this.logo.length > 0 && this.logo[0].file === '') {
              this.logosDeletes.push(this.logo[0])
            }
            this.logo = [];
            this.logo = this.logo.concat.apply(this.logo, arrTemp);
            // console.log(this.images)
            // await this.validateData()
          }
        }
      }
    },
    onFileClear(index) {
      let img = this.images[index];
      this.images.splice(index, 1);
      if (img.file === '') {
        this.imgDelete.push(img)
      }
    }
  },
  apollo: {
    
  }
}
</script>

<style lang="scss">
#frm_action {
  .p-multiselect {
    width: 450px;
  }
  .p-multiselect-label:not(.p-placeholder) {
    padding-top: .25rem;
    padding-bottom: .25rem;
    
  }
  .category-item-value {
    padding: .25rem .5rem;
    border-radius: 3px;
    display: inline-flex;
    margin-right: .2rem;
    background-color: var(--primary-color);
    color: var(--primary-color-text);
  }
  .p-multiselect-label-container{
    height: 40px;
  }
  .p-invalid {
    color: red;
    margin: 1px 0px 0px 0px;
  }
  .text-active{
    margin: 0px 0px 0px 8px;
  }
  .color{
    color: red!important;
  }
  .text-active{
    padding: 0px!important;
    margin-bottom: 0px!important;
  }
  .div-active{
    display: flex!important;
    margin-bottom: 12px!important;
  }
  .div-active-item{
    max-width: 120px!important;
    width: 50px!important;
    display: flex!important;
    align-items: flex-start!important;
  }
  .div-p{
    text-align: left!important;
    justify-content: left!important;
  }
  .text-distance{
    display: block!important;
  }
  .div-block{
    display: block!important;
    padding-left: 12px!important;
  }
  .div-big{
    padding: 0px!important;
  }
  .label-thumbnail{
    display: unset!important;
    //margin: 12px!important;
  }
  .label-bot-item{
    display: block!important;
    text-align: left!important;
  }
  .div-calenda{
    display: flex!important;
  }
  .bold{
    font-weight: bold!important;
  }
  #div-thumbnail{
    width: 650px!important;
  }
  .link-width{
    width: 650px!important;
    margin-left: 7px!important;
  }
  .color-text{
    color: #808080;
  }
  .div-canlenda-item{
    margin-right: 12px!important;
  }
  .col-12{
    padding-left: 5px!important;
  }
  .p-formgrid .p-card-field{
    padding: unset !important;
  }
  .p-col{
    padding: 0px!important;
  }
  .p-col-fixed{
    padding: 0px!important;
  }
  /* .p-calendar-w-btn{
    width: 319px!important;
  } */
  .width-thum{
    margin-top: 12px!important;
  }
    //.pi-check{
    //  background-color:#E73725 !important;
    //  border: 1px solid #E73725;
    //}

    .save{
      background-color: #E73725!important;
      border: 1px solid #E73725!important;
    }
    .cancel{
      border: 1px solid #E73725!important;
      color: #E73725!important;
    }
    .one-active{
      margin-left: 5px!important;
    }
    
    .transform-upper-case {
      font-size: 16px;
      font-weight: bold;
      text-transform: uppercase;
      padding-bottom: 7px;
  }
    
  .p-component:disabled {
    background-color: #EEEEEE;
    border-color: #D0D4D9;
    color: #666666;
  }  
  .chip__select_multi{
    background-color: #F2F3F7;
    .p-chip-text {
      color: #000;
    }
  }

  .cus-tags{
    border-radius: 18px;
    padding: 8px;
    margin-right: 10px;
    background-color:#F2F3F7;
  }
  .cs-tag {
    padding: 10px 12px 10px 0px;
  }
  .cs-icon {
    color : #666666;
    padding-right: 4px;
    cursor: pointer;
  }

  #id_69 .vs__selected {
    display: none;
  }

  .p-inputnumber.p-component.p-inputwrapper-filled.p-inputnumber-buttons-horizontal input{
    text-align: center !important;
  }

  .box-experience {
    .border {
      border-radius: 5px;
    }
  }
  .border {
    border-color: #D0D4DA !important;
  }
    
  .no-border input {
      color: #000 !important;
      text-align: center !important;
      outline: unset !important;
      box-shadow: unset !important;
      border-color: unset !important;
      border: unset !important;
  }
  .number-box {
    input, button span {
      font-weight: bold;
      color: #666666;
    }
  }

  .vs__dropdown-option--highlight {
    background-color: #E73725 !important;
  }

  .club-form .p-formgrid .p-card-field .p-field .p-col-width {
    width: 100% !important;
  }
}  
</style>
